import React, {
  useContext, useState,
} from 'react';
import OliMaterialTable from 'components/OliMaterialTable/OliMaterialTable';
import {
  Action, MTQuery,
} from 'components/OliMaterialTable/OliMaterialTable.types';
import EditIcon from '@mui/icons-material/Edit';
import OliAxios from 'api/util/OliAxios';
import { getConfig } from 'api/util/getConfig';
import UserContext from 'context/UserContext';
import {
  Link, useParams,
} from 'react-router-dom';
import {
  MaterialTableProps, Query,
} from '@material-table/core';
import { useTheme } from '@mui/material/styles';
import {
  Scrub,
} from './Scrub.types';
import ScrubModal from './ScrubModal';

const ScrubList:React.FunctionComponent = () => {
  const theme = useTheme();
  const tableRef = React.useRef();
  const [openModal, setOpenModal] = useState(false);
  const token = useContext(UserContext)?.token;
  const { matterUUID } = useParams();
  const [modalData, setModalData] = useState<Scrub>();

  // eslint-disable-next-line
  const constructUrl = (query:Query<object>): string => {
    const qsp: string[] = [];
    const url = '/scrub/list';
    if (query.filters) {
      query.filters.forEach((f) => {
        qsp.push(`${f.column.field as string}=${f.value as string}`);
      });
    }
    if (matterUUID) {
      qsp.push(`matterUUID=${matterUUID}`);
    }
    qsp.push(`per_page=${query.pageSize}`);
    qsp.push(`page=${query.page + 1}`);

    if (query.orderBy && query.orderDirection) {
      qsp.push(`order=${query.orderBy.field as string}`);
      qsp.push(`orderDirection=${query.orderDirection}`);
    }

    const queryStringParams = qsp.join('&');
    if (queryStringParams.length > 0) {
      return `${url}?${queryStringParams}`;
    }
    return url;
  };

  const getList = ():void => {
    if (tableRef && tableRef.current) {
      (tableRef.current as MaterialTableProps<Record<string, unknown>>)?.onQueryChange?.();
    }
  };

  const handleClose = (e:Record<string, unknown>, reason:string):void => {
    if (reason !== 'backdropClick') {
      setOpenModal(false);
      getList();
      setModalData(undefined);
    }
  };

  const styles = {
    link: {
      textDecoration: 'none',
      color: theme.palette.secondary.main,
    },
  };

  const columns = [
    {
      title: 'Matter Reference',
      field: 'external_account_id',
      render: (rowData: Scrub) => (
        <Link style={styles.link} to={`/matter/${rowData.matter_uuid}`}>{rowData.external_account_id}</Link>
      ),
    },
    {
      title: 'Scrub Event', field: 'scrub_type',
    },
    {
      title: 'Generated On', field: 'generated_on',
    },
    {
      title: 'State', field: 'state_prov_code',
    },
    {
      title: 'Status', field: 'status',
    },
  ];

  const handleClick = (rowData:Scrub):void => {
    setModalData(rowData);
    setOpenModal(true);
  };

  const actions:Action[] = [{
    icon: () => <EditIcon />,
    tooltip: 'View',
    onClick: (_e, rowData) => handleClick(rowData as Scrub),
  }];

  const renderModal = ():JSX.Element => {
    if (modalData) {
      return (<ScrubModal open={openModal} handleClose={handleClose} modalData={modalData} />);
    }
    return <></>;
  };

  return (
    <div>
      {renderModal()}
      <OliMaterialTable
        tableRef={tableRef}
        title="Scrubs"
        columns={columns}
        data={(query) => new Promise((resolve) => {
          const url = constructUrl(query);
          OliAxios.get(url, { ...getConfig(token || '') })
            .then((response) => response.data as unknown as MTQuery)
            .then((result) => {
              resolve({
                data: result.data,
                page: parseInt(result.page, 10) - 1,
                totalCount: parseInt(result.total, 10),
              });
            })
            .catch((e) => console.error(e));
        })}
        pagesize={5}
        actions={actions}
        selectable={false}
        filter
      />
    </div>
  );
};

export default ScrubList;
